import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function MoreHorizontal({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M17.4902 12C17.4902 12.28 17.7102 12.5 17.9902 12.5C18.2602 12.5 18.4902 12.28 18.4902 12C18.4902 11.73 18.2602 11.5 17.9902 11.5C17.7102 11.5 17.4902 11.73 17.4902 12.01M11.4902 12C11.4902 12.28 11.7102 12.5 11.9902 12.5C12.2602 12.5 12.4902 12.28 12.4902 12C12.4902 11.73 12.2602 11.5 11.9902 11.5C11.7102 11.5 11.4902 11.73 11.4902 12.01M5.49023 12C5.49023 12.28 5.71023 12.5 5.99023 12.5C6.26023 12.5 6.49023 12.28 6.49023 12C6.49023 11.73 6.26023 11.5 5.99023 11.5C5.71023 11.5 5.49023 11.73 5.49023 12.01" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default MoreHorizontal;